import React from 'react';

/**
 * 
 * iconClass="lnr-book" label="Refresh Invoices" badge="5" badgeClass="badge-danger"
 * 
 */
const ActionDropdownItem = ({ iconClass, label, badge, badgeClass, disabled, onClick, className }) => {
    return (
        <li className="nav-item">
        <button className={`nav-link dropdown-item ${className || ''}`} onClick={onClick} disabled={disabled ? true : false}>
            <i className={`nav-link-icon ${iconClass}`}></i>
            <span> {label}</span>
            {badge && <div className={`ml-auto badge badge-pill ${badgeClass}`}>{badge}</div>}
        </button>
    </li>
    );
};

export default ActionDropdownItem;